/* eslint-disable */

document.addEventListener('DOMContentLoaded', function () {
  // Add the src and a condition required to load the script
  window.ScriptLoader = ScriptLoader({
    './to-sort/old': true,
    './blocks/product-slider': true,
    './blocks/tabbed-resources': true,
    './indexed-search/index': true,
    './components/equalizer': true,
    './components/in-view': true,
    './components/accordions': document.querySelector('.js-accordion'),
    './components/parallax': document.querySelector('[data-parallax]'),
    './pages/history': document.querySelector('.js-history'),
    './pages/return-to-gate': document.querySelector('.js-return-to-gate'),
    './calculators/head-loss/index': document.querySelector('.js-headloss-calculator'),
    './calculators/head-loss/view': document.querySelector('.js-flow-app')
  });
});

/*------------------------------------------------------------------
Script Loader
------------------------------------------------------------------*/

window.ScriptLoader = function () {
  var imports = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var evt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'scripts-loaded';
  // An array of the import object keys
  var scripts = Object.keys(imports).filter(function (key) {
    return imports[key];
  });
  // For debugging purposes only
  var components = [];
  Promise.all(scripts.map(function (script) {
    return import("".concat(script)).then(function () {
      return components.push(script);
    })["catch"](function (error) {
      return console.warn(error);
    });
  })).then(function () {
    return setTimeout(function () {
      return window.dispatchEvent(new Event(evt));
    }, 500);
  });
  return components;
};

/*------------------------------------------------------------------
Scripts Loaded
------------------------------------------------------------------*/

window.addEventListener('scripts-loaded', function () {
  console.log("%cmarmalade", "color:#0c0c0d; font-family: monospace; font-size: 20px; padding: 5px 10px; border-radius: 5px; background-color: #bbb");
  document.body.classList.add('scripts-loaded');
});